import React from 'react';
import styled from 'styled-components';
import { Header } from '@app/navigation/header';
import { Body } from '@ui';
import { useNavigate } from 'react-router';
import { ROUTES } from '@constants/routes';
import { scrollToTop } from '@utils/usefulFuncs';
import NewQueryTool from '@containers/DigitalAnalyst/NewQueryTool';
import { AI_TOOLS, DOC_SELECT_MODES } from '@constants';
import { Body5, Container, Page, SVG_LOADING_ICON_TYPES, SvgLoadingIcon } from '@ui';
import BackArrowButton from '@ui/buttons/BackArrowButton';
import { usePreselectedDocs } from '@hooks/features/usePreselectedDocs';
import { useColorTheme } from '@hooks';

const PageWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
`;

const tool = AI_TOOLS.FED_QUERY;

function FedDigitalAnalyst() {
  const colorTheme = useColorTheme();
  const navigate = useNavigate();

  const onGoBack = () => navigate(ROUTES.home);

  const { complete: completedPreselectDocs, preSelectedDocs } = usePreselectedDocs();

  const [docModes] = React.useState([
    DOC_SELECT_MODES.fedDoc,
    DOC_SELECT_MODES.speaker,
    DOC_SELECT_MODES.allCompany,
    DOC_SELECT_MODES.myDocs,
  ]);

  React.useEffect(() => {
    scrollToTop();
  }, []);

  if (!completedPreselectDocs) {
    return (
      <PageWrapper>
        <Header />
        <Body withFooter>
          <Page width={'600px'}>
            <BackArrowButton onClick={onGoBack} />
            <Container top={99} centerAll bottom={99}>
              <SvgLoadingIcon type={SVG_LOADING_ICON_TYPES.bars} color={colorTheme.text} />
              <Container left={8}>
                <Body5>Loading Documents...</Body5>
              </Container>
            </Container>
          </Page>
        </Body>
      </PageWrapper>
    );
  }

  return (
    <PageWrapper>
      <Header />
      <Body withFooter>
        <NewQueryTool
          onGoBack={onGoBack}
          isFedMode
          preSelectedDocs={preSelectedDocs}
          tool={tool}
          docModes={docModes}
          defaultActiveDocSelectMode={DOC_SELECT_MODES.fedDoc}
        />
      </Body>
    </PageWrapper>
  );
}

export default FedDigitalAnalyst;
